export const TEAM_CLASSIFICATIONS = [
    { value: "A_And_E", label: "A&E", description: "" },
    { value: "Administration", label: "Administration", description: "" },
    { value: "Allied_Care", label: "Allied Care", description: "" },
    { value: "Ancillary", label: "Ancillary", description: "Radiology, Pharmacy, Allied Health, etc..." },
    { value: "CareFacilities", label: "Care Facilities", description: "Aged care, Hospices, etc..." },
    { value: "Charity", label: "Charity", description: "" },
    { value: "Home_Care", label: "Home Care", description: "" },
    { value: "Maternity", label: "Maternity", description: "" },
    { value: "Medical", label: "Medical - Long Stay", description: "" },
    { value: "Medical_Short_Stay", label: "Medical - Short Stay", description: "" },
    { value: "Outpatients", label: "Outpatients", description: "" },
    { value: "Paediatric_Medical", label: "Paediatric - Medical", description: "" },
    { value: "Paediatric_Surgical", label: "Paediatric - Surgical", description: "" },
    { value: "Primary_Care_GP", label: "Primary Care/GP", description: "" },
    { value: "Resident_Care", label: "Resident Care", description: "" },
    { value: "Surgical_DaySurgery", label: "Surgical - Day Surgery", description: "" },
    { value: "Surgical_LongStay", label: "Surgical - Long Stay", description: "" },
    { value: "Theatres", label: "Theatres", description: "Recovery, Endoscopy, etc..." },
    { value: "Virtual_Care", label: "Virtual Care", description: "" },

];